import {
  View,
  Text,
  StyleSheet,
  Image,
  ScrollView,
  Platform,
} from "react-native";
import AppLoading from "expo-app-loading";
import { useFonts, Limelight_400Regular } from "@expo-google-fonts/limelight";
import Marvel from "../../assets/Marvel.png";
import Haunted from "../../assets/haunted.jpg";
import Decidr from "../../assets/Decidr.png";
import Ecard from "../../assets/Ecard.png";
export default function Portfolio() {
  let [fontsLoaded] = useFonts({
    Limelight_400Regular,
  });
  if (!fontsLoaded) {
    return <AppLoading />;
  }
  return (
    <ScrollView>
      <View style={styles.container}>
        <Text style={styles.portfolio}>Portfolio</Text>
        <Text style={styles.portfolioSub}>Some of my best works</Text>
       <View>
          <View style={styles.wrapper}>
              <Text style={styles.Marvel}>Marvel Space</Text>
              <Text style={styles.textWrapper}>
                React-Native components for Android and web applications. A user
                will be able to customize the theme for their MySpace page,
                create an account, send messages, friend requests, post
                pictures, add feed posts and search for profiles
              </Text>
              <Image style={styles.marvel} source={Marvel} alt="" />
          </View>

          <View style={styles.wrapper}>
           
            <Text style={styles.Haunted}>Haunted House</Text>
            <Text style={styles.textWrapper}>
              Haunted house is an interactive Halloween themed game built using
              React. During trick-or-treating, the players end up stuck in a
              haunted house. To get out of the haunted house, they need to find
              the key, but first they must explore each room and complete the
              challenges to find the silver key.
            </Text>
            <Image style={styles.haunted} source={Haunted} alt="" />
          </View>
        </View>

        <View style={styles.wrapper}>
       
            
            <Text style={styles.Decidr}> Decidr</Text>
            <Text style={styles.textWrapper}>
              The Decider app was developed using React. This app is designed to
              help users select from an arbitrary list of options. Users can add
              and remove options from the list at any time. Once the user is
              done, the app selects a random option from the list. Responsive on
              both mobile and desktop
            </Text>
            <Image style={styles.decidr} source={Decidr} alt="" />
          
        </View>

        <View style={styles.wrapper}>
          <Text style={styles.Ecard}>ecard</Text>
          <Text style={styles.textWrapper}>
            A React app that creates custom greeting cards for the holiday
            season. It is easy to customize and reshare with friends and family.
            Responsive on both mobile devices and web pages.See it in action by
            clicking the live demo and start resharing
          </Text>
          <Image style={styles.ecard} source={Ecard} alt="" />
        </View>
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#000304",
  },
  marvel: {
    width: 150,
    height: 150,
    alignSelf: "center",
    marginBottom:25
  },
  haunted: {
    width: 150,
    height: 150,
    alignSelf: "center",
    marginBottom:25,
    borderRadius:100,
    
  },
  decidr: {
    width: 150,
    height: 150,
    alignSelf: "center",
    marginBottom:25,
    
  },
  ecard: {
    width: 150,
    height: 150,
    alignSelf: "center",
    marginBottom:25
  },
  portfolio: {
    textAlign: "center",
    fontSize: 35,
    fontWeight: "bold",
    marginTop: 15,
    fontFamily: "Limelight_400Regular",
    color: "#F2D379",
  },
  portfolioSub: {
    marginTop: 10,
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 15,
    color: "#ffffff",
    fontStyle: "italic",
  },
  Marvel: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: 20,
    fontSize: 20,
    color: "#000",
  },
  Haunted: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: 20,
    fontSize: 20,
    color: "#000",
  },
  Decidr: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: 20,
    fontSize: 20,
    color: "#000",
  },
  Ecard: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: 20,
    fontSize: 20,
    color: "#000",
  },
  wrapper: {
    maxWidth: Platform.OS === "web" ? 600 : 350,
    shadowColor: "#33ccff",
    backgroundColor: "#776a6cc2",
    marginBottom: 30,
    borderRadius: 15,
    // opacity: 0.4,

    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,

    elevation: 24,

    flexWrap: "wrap",
  },
  textWrapper: {
    color: "#fff",

    padding: 15,
    maxWidth: Platform.OS === "web" ? 600 : 350,
    marginTop:5,

    alignContent: "center",
  },
});

// import * as React from 'react';
// import {  Avatar, Button, Card, Title, Paragraph, View, Text, ScrollView } from 'react-native-paper';

// const LeftContent = props => <Avatar.Icon {...props} icon="folder" />

// const MyComponent = () => (
//   <Card style={{maxWidth:600, maxHeight:600, width:"100%", marginTop:15, marginRight:'auto', marginLeft:'auto', backgroundColor:'black'}}>
//     <Card.Title title="Marvel Space" subtitle="React Native" left={LeftContent} />

//     <Card.Cover source={{ uri: 'https://picsum.photos/700' }} style={{padding:5, borderRadius:10, backgroundColor:'black'}}/>
//     <Card.Content>
//       <Title>Marvel Space</Title>
//       <Paragraph>Card content</Paragraph>
//     </Card.Content>
//     <Card.Actions>
//       <Button>Cancel</Button>
//       <Button>Ok</Button>
//     </Card.Actions>
//   </Card>

// );
// export default MyComponent;
